import { gql } from '@apollo/client'

export type {
  UseDocumentFeatureMutationMutation,
  UseDocumentFeatureMutationMutationVariables,
} from './__generated__/use-document-feature-mutation.graphql'

export const UseDocumentFeatureMutation = gql`
  mutation useDocumentFeatureMutation($input: UseDocumentFeatureInput!) {
    useDocumentFeature(input: $input) {
      profile {
        id
      }
    }
  }
`
